import { externalLink } from '../app/themes/PartnerTheme/partnerTheme.helpers';
import { Union } from '../app/themes/themes.types';

export const ROOT = 'mine-forsikringssider';
export const CLAIMS = 'meld-skade';
export const CLAIMS_FROM_POLICY = 'fra-polise';
export const LIMITED_DETAILS = 'flere-detaljer';
export const DETAILS = 'avtale';
export const CORPORATE_DETAILS = 'avtale-bedrift';
export const CORPORATE_INSURANCE = 'bedriftsbetalt-forsikring';
export const STB_ROOT = 'https://www.storebrand.no';
export const PRIVATE = 'privat';
export const INSURANCE = 'forsikring';
export const REREGISTER = 'paregistrer';

export const BUY_INSURANCE = 'kjop-forsikring/sjekk-pris';

export const COVERAGE_DOCUMENT = `${STB_ROOT}/filbibliotek/_/attachment/inline/c8f04e6a-8358-48c5-8b98-d295b68e29d1/storebrand-forsikringer-og-dekninger.pdf`;

export const RIGHT_OF_WITHDRAWAL_INFO = `${STB_ROOT}/om-storebrand/angrerett`;

export const KRY_LINK = `${STB_ROOT}/${PRIVATE}/${INSURANCE}/reiseforsikring/kry`;

export const SMART_DELAY_LINK = 'https://norsk.smartdelay.com/Storebrand';

export const RIGHT_OF_WITHDRAWAL_LIFE_DOCUMENT = `${STB_ROOT}/om-storebrand/angrerett/_/attachment/inline/a41a547c-4210-4f61-a831-b06065c51120:d0a7c6ee44aac57c9fa00e13251a513c966b6ffc/Angreskjema-Livsforsikring.pdf`;
export const RIGHT_OF_WITHDRAWAL_RISK_DOCUMENT = `${STB_ROOT}/om-storebrand/angrerett/_/attachment/inline/8672b568-ab8d-4117-9f78-55aa096d0849:bdeeaba053a0cb52a15c6c0b063b8734fa43391b/Angreskjema-Skadeforsikring.pdf`;
export const RIGHT_OF_WITHDRAWAL_HEALTH_DOCUMENT = `${STB_ROOT}/om-storebrand/angrerett/_/attachment/inline/2d66c74b-ab3a-4887-877b-0bdb00a84fa0:2de7480f4f847deb80af52d1371032db734aa310/Angreskjema-Helseforsikring.pdf`;

export const SECURE_MESSAGES_DIALOG = externalLink(
  'meldinger/ny/?level1=insurance&level2=insurance.change&level3=insurance.change.person',
);
export const SECURE_MESSAGES_OVERVIEW_PAGE = externalLink('meldinger');
export const SECURE_MESSAGES_NEW = externalLink('meldinger/ny');
export const SECURE_MESSAGES_NEW_COLLECTIVE_LIFE = externalLink(
  'meldinger/ny/?level1=pension&level2=pension.collective.life',
);

export const AKA_UNION_TO_BUY_MORE_INSURANCES_PATH: {
  [key in Exclude<Union, undefined>]: string;
} = {
  akaAfag: 'afag',
  akaEcona: 'legeforeningen',
  akaLegeforeningen: 'tannlegeforeningen',
  akaNaturviterne: 'naturviterne',
  akaNl: 'lektorlaget',
  akaPsykologiforeningen: 'psykologforeningen',
  akaSamfunnsviterne: 'samfunnsviterne',
  akaSamfunnsøkonomene: 'samfunnsokonomene',
  akaTannlegeforeningen: 'tannlegeforeningen',
  akaVeterinærforeningen: 'veterinarene',
};

export const RENEWAL_DOCUMENT = `${STB_ROOT}/filbibliotek/_/attachment/inline/f3f5fe3b-f6cf-49ff-bf19-d56ea58b5ef5/fornyelse-storebrand-forsikring.pdf`;
export const RENEWAL_DOCUMENT_AKA = `${STB_ROOT}/filbibliotek/_/attachment/inline/4d114483-4635-457e-8c86-5e3b671b4301/akademikerne-forsikringer-og-fornyelser.pdf`;
export const REPORT_DAMAGE_CHILD_INSURANCE = `${STB_ROOT}/${PRIVATE}/${INSURANCE}/${CLAIMS}`;
export const REPORT_DAMAGE_HOME_SELLER_INSURANCE = `${STB_ROOT}/privat/forsikring/meld-skade/hus-hytte-og-innbo/boligselgerforsikring`;
export const REPORT_DAMAGE_HOME_BUYER_INTEREST_INSURANCE = `${STB_ROOT}/privat/forsikring/meld-skade/hus-hytte-og-innbo/renteforsikring`;
export const REPORT_DAMAGE_HOME_BUYER_MOVE_INSURANCE = `${STB_ROOT}/privat/forsikring/meld-skade/hus-hytte-og-innbo/flytteforsikring`;
export const REPORT_DAMAGE_HOME_BUYER_HOUSE_AND_CONTENTS_INSURANCE = `${STB_ROOT}/privat/forsikring/meld-skade/hus-hytte-og-innbo`;
export const REPORT_DAMAGE_AKA_STUDENT_INSURANCE = `${STB_ROOT}/${PRIVATE}/${INSURANCE}/${CLAIMS}/student`;
export const REPORT_DAMAGE_DEFAULT_ROOT = `${CLAIMS}/${CLAIMS_FROM_POLICY}/`;

export const SUMMER_CAMPAIGN_GENERAL_LINK: {
  [key: string]: string;
} = {
  stb: 'https://www.storebrand.no/privat/forsikring/klar-for-ferien?utm_source=mine%20sider&utm_medium=egne%20kanaler&utm_campaign=sommerkampanje',
  akademikerne: 'https://www.storebrand.no/akademikerne/klar-for-ferien',
  huseierne: 'https://www.storebrand.no/privat/huseierne/klar-for-ferien',
  coop: 'https://www.storebrand.no/privat/coop/klar-for-ferien',
};

export const SUMMER_CAMPAIGN_TRAVEL_LINK: {
  [key: string]: string;
} = {
  stb: 'https://www.storebrand.no/privat/forsikring/reiseforsikring?utm_source=mine%20sider&utm_medium=egne%20kanaler&utm_campaign=sommerkampanje',
  huseierne:
    'https://www.storebrand.no/privat/huseierne/forsikring/reiseforsikring?utm_source=Mine%20sider&utm_medium=egen%20kanaler&utm_campaign=sommerkampanje&utm_term=huseierne',
  coop: 'https://www.storebrand.no/privat/coop/reiseforsikring?utm_source=Mine%20sider&utm_medium=egen%20kanaler&utm_campaign=sommerkampanje&utm_term=coop',
};

export const SUMMER_CAMPAIGN_ELECTRIC_SCOOTER_LINK: {
  [key: string]: string;
} = {
  stb: 'https://www.storebrand.no/privat/forsikring/elsparkesykkelforsikring?utm_source=mine%20sider&utm_medium=egne%20kanaler&utm_campaign=sommerkampanje',
  akademikerne:
    'https://www.storebrand.no/akademikerne/akademikernepluss/elsparkesykkelforsikring?utm_source=Mine%20sider&utm_medium=egen%20kanaler&utm_campaign=sommerkampanje&utm_term=aka',
  huseierne:
    'https://www.storebrand.no/privat/huseierne/forsikring/elsparkesykkelforsikring?utm_source=Mine%20sider&utm_medium=egen%20kanaler&utm_campaign=sommerkampanje&utm_term=huseierne',
  coop: 'https://www.storebrand.no/privat/coop/elsparkesykkelforsikring?utm_source=Mine%20sider&utm_medium=egen%20kanaler&utm_campaign=sommerkampanje&utm_term=coop',
};

export const BUY_INSURANCE_LINK = {
  AKA_HOUSE_CONTENTS: `${BUY_INSURANCE}/aka-innbo/din-innboforsikring?grp=afag`,
};

export const DOWNLOAD_EYR_APP =
  'https://www.storebrand.no/privat/forsikring/barneforsikring/eyr-helsetjenester-pa-mobilen';

export const USE_HEALTH_INSURANCE_LINK =
  'https://www.storebrand.no/privat/forsikring/helseforsikring/slik-bruker-du-forsikringen';
